"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  /* enumValues is object, property names are enum keys, property values are an array
     where first value is client side representation and second value is server side representation.
     i.e. AnimalType definition = { Dog: ['dog', 0], Cat: ['cat', 1] };
  */
  var Enum = /*#__PURE__*/function () {
    function Enum(enumValues) {
      _classCallCheck(this, Enum);

      this.defineWith(enumValues);
    }

    _createClass(Enum, [{
      key: "defineWith",
      value: function defineWith(enumValues) {
        this._clientToServerMapping = {};
        this._serverToClientMapping = {};

        for (var enumKey in enumValues) {
          var clientSideValue = enumValues[enumKey][0];
          var serverSideValue = enumValues[enumKey][1];
          this[enumKey] = clientSideValue;
          this._clientToServerMapping[clientSideValue] = serverSideValue;
          this._serverToClientMapping[serverSideValue] = clientSideValue;
        }
      }
    }, {
      key: "parseFromServer",
      value: function parseFromServer(serverSideValue) {
        return this._serverToClientMapping[serverSideValue];
      }
    }, {
      key: "convertToServer",
      value: function convertToServer(clientSideValue) {
        return this._clientToServerMapping[clientSideValue];
      }
    }], [{
      key: "define",
      value: function define(enumValues) {
        return new Enum(enumValues);
      }
    }]);

    return Enum;
  }();

  Kobo.Utilities.assignToNamespace('Kobo.Enum', Enum);
})();